import { render, staticRenderFns } from "./new_operation_btn.vue?vue&type=template&id=ecf6da20&scoped=true&"
import script from "./new_operation_btn.vue?vue&type=script&lang=js&"
export * from "./new_operation_btn.vue?vue&type=script&lang=js&"
import style0 from "./new_operation_btn.vue?vue&type=style&index=0&id=ecf6da20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf6da20",
  null
  
)

export default component.exports